import { effect, Injectable, OnDestroy } from '@angular/core';
import * as Sentry from '@sentry/angular';

import { AuthStore } from '../auth/auth.store';

/** Interfaz del handle que devuelve createWidget() */
interface SentryWidgetHandle {
  appendToDom: () => void;
  removeFromDom: () => void;
}

@Injectable({ providedIn: 'root' })
export class SentryFeedbackService implements OnDestroy {
  private widget: SentryWidgetHandle | null = null;

  constructor(private readonly authStore: AuthStore) {
    // Reacciona a cambios en el estado de autenticación.
    // Cuando el usuario se autentica → crea el widget.
    // Cuando cierra sesión → lo destruye.
    effect(() => {
      const isAuthenticated = this.authStore.isAuthenticated();

      if (isAuthenticated && !this.widget) {
        this.createWidget();
      } else if (!isAuthenticated && this.widget) {
        this.destroyWidget();
      }
    });
  }

  private createWidget(): void {
    const feedback = Sentry.getFeedback();

    if (feedback) {
      const widget = feedback.createWidget();
      widget.appendToDom();
      this.widget = widget;
    }
  }

  private destroyWidget(): void {
    this.widget?.removeFromDom();
    this.widget = null;
  }

  ngOnDestroy(): void {
    this.destroyWidget();
  }
}
